import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchAPI from "../../../utils/axios";

const getErrorMessage = (error, fallback) => error?.response?.data?.error || fallback;

export const registerLmsUser = createAsyncThunk(
  "lms/registerUser",
  async (registrationData, thunkAPI) => {
    try {
      const response = await fetchAPI.post("/auth/register", registrationData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error, "Registration failed"));
    }
  }
);

export const loginLmsUser = createAsyncThunk(
  "lms/loginUser",
  async (credentials, thunkAPI) => {
    try {
      const response = await fetchAPI.post("/lms/login", credentials);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(getErrorMessage(error, "Login failed"));
    }
  }
);
